import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { useStdCreativeAdgroupIs } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';

type CommonOptions = {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
};

export function usePropsDisabled(
  options: CommonOptions & {
    isDisabledCreative: Ref<boolean>;
  },
) {
  const { adgroupData, campaignData, isDisabledCreative } = options;
  const { isIos14Creative } = useStdCreativeAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  return {
    disabled: computed(() => isIos14Creative.value || isDisabledCreative.value),
  };
}

export function useSwitchPropsHint(options: CommonOptions) {
  const { adgroupData, campaignData } = options;

  const { isIos14Creative } = useStdCreativeAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  const hint = computed(() =>
    isIos14Creative.value
      ? i18n.t('module_ios14_deffered_deeplink_disable_hint')
      : i18n.t('module_creative_deferred_deeplink_tip'),
  );

  return {
    hint,
  };
}
